const stripTrailingSlash = (value?: string) => (value ?? "").trim().replace(/\/+$/, "");

const isProduction = process.env.NODE_ENV === "production";

const fallbackApiUrl = isProduction
  ? "https://appp.cryprtorq.com.ng/public/api"
  : "http://127.0.0.1:8000/api";

const fallbackFileUrl = isProduction
  ? "https://appp.cryprtorq.com.ng/public"
  : "http://127.0.0.1:8000";

export const API_BASE_URL =
  stripTrailingSlash(process.env.REACT_APP_API_URL) || fallbackApiUrl;

export const FILE_BASE_URL =
  stripTrailingSlash(process.env.REACT_APP_BASE_URL) || fallbackFileUrl;

export const IS_PRODUCTION = isProduction;
